import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { socialIcons as defaultSocialIcons } from "../data/Data";

export default function Footer() {
  const [settings, setSettings] = useState(() => {
    try {
      const saved = localStorage.getItem("hk_resort_settings");
      if (saved) return JSON.parse(saved);
    } catch (e) {}
    return null;
  });

  useEffect(() => {
    const handleStorage = () => {
      try {
        const saved = localStorage.getItem("hk_resort_settings");
        if (saved) setSettings(JSON.parse(saved));
      } catch (e) {}
    };
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  const phone = settings?.phone || "+91 9602588882";
  const email = settings?.email || "info@harikunjresort.com";
  const address = settings?.address || "Gopal Badi, Chopasni, Jodhpur, 342008 Rajasthan";

  const instagramLink = settings?.instagram || defaultSocialIcons[0].link;
  const facebookLink = settings?.facebook || defaultSocialIcons[1].link;
  const youtubeLink = settings?.youtube || defaultSocialIcons[2].link;
  const locationLink = settings?.locationUrl || defaultSocialIcons[3].link;

  const showInstagram = settings?.showInstagram !== false;
  const showFacebook = settings?.showFacebook !== false;
  const showYoutube = settings?.showYoutube !== false;
  const showLocation = settings?.showLocation !== false;
  const showNewsletter = settings?.showNewsletter !== false;

  const activeSocials = [
    showInstagram && { icon: <i className="fab fa-instagram" />, link: instagramLink, name: "Instagram" },
    showFacebook && { icon: <i className="fab fa-facebook-f" />, link: facebookLink, name: "Facebook" },
    showYoutube && { icon: <i className="fab fa-youtube" />, link: youtubeLink, name: "YouTube" },
    showLocation && { icon: <i className="fas fa-map-marker-alt" />, link: locationLink, name: "Location" }
  ].filter(Boolean);

  const renderMultiFooterLinks = (str, type = "phone") => {
    if (!str) return null;
    const tokens = str.split(/([&/,])/);
    return tokens.map((token, idx) => {
      const trimmed = token.trim();
      if (trimmed === "&" || trimmed === "/" || trimmed === ",") {
        return <span key={`fsep-${idx}`} className="mx-1 text-light-50 fw-bold" style={{ opacity: 0.6 }}>{trimmed}</span>;
      }
      if (!trimmed) return null;
      if (type === "email") {
        return (
          <a key={`fem-${idx}`} href={`mailto:${trimmed}`} style={{ color: "inherit", textDecoration: "none" }}>
            {trimmed}
          </a>
        );
      }
      const numOnly = trimmed.replace(/[^0-9+]/g, "");
      return (
        <a key={`fph-${idx}`} href={`tel:${numOnly}`} style={{ color: "inherit", textDecoration: "none" }}>
          {trimmed}
        </a>
      );
    });
  };

  const [newsletterEmail, setNewsletterEmail] = useState("");
  const [newsletterMsg, setNewsletterMsg] = useState("");
  const [isSubmittingNews, setIsSubmittingNews] = useState(false);

  const handleSubscribeNewsletter = (e) => {
    e.preventDefault();
    if (!newsletterEmail.trim()) return;
    setIsSubmittingNews(true);

    try {
      const existing = JSON.parse(localStorage.getItem("hk_vip_subscribers") || "[]");
      const clean = newsletterEmail.trim();
      const newSub = {
        id: "SUB-" + Date.now(),
        email: clean,
        subscribedAt: new Date().toISOString()
      };
      if (!existing.some(s => (s.email || "").toLowerCase() === clean.toLowerCase())) {
        existing.unshift(newSub);
        localStorage.setItem("hk_vip_subscribers", JSON.stringify(existing));
        window.dispatchEvent(new Event("storage"));
      }
      setNewsletterMsg("🎉 Thank you for subscribing to HariKunj Royal VIP updates!");
      setNewsletterEmail("");
    } catch (err) {
      setNewsletterMsg("❌ Subscription failed. Please try again.");
    } finally {
      setIsSubmittingNews(false);
      setTimeout(() => setNewsletterMsg(""), 5000);
    }
  };

  return (
    <footer className="hk-footer-wrapper text-light">
      <div className="hk-footer-overlay" />

      <div className="container hk-footer-inner">
        {/* Modern Newsletter & Special Offer Banner */}
        {showNewsletter && (
          <div className="hk-footer-newsletter p-4 p-md-4 rounded-4 mb-5" style={{ background: "rgba(255, 255, 255, 0.05)", border: "1px solid rgba(212, 175, 55, 0.35)", backdropFilter: "blur(10px)" }}>
            <div className="row align-items-center g-3">
              <div className="col-lg-6">
                <h5 className="mb-1 text-warning font-serif" style={{ letterSpacing: "0.08em" }}>
                  <i className="fas fa-crown me-2"></i>Royal Updates &amp; Special Offers
                </h5>
                <p className="mb-0 text-light-50 small" style={{ color: "rgba(250, 242, 230, 0.8)" }}>
                  Subscribe to receive seasonal retreat tariffs, exclusive wedding offers, and desert getaway privileges.
                </p>
              </div>
              <div className="col-lg-6">
                <form onSubmit={handleSubscribeNewsletter} className="d-flex flex-column gap-2">
                  <div className="d-flex gap-2">
                    <input
                      type="email"
                      required
                      placeholder="Enter your email address..."
                      className="form-control rounded-pill border-0 px-3"
                      style={{ background: "#FFFFFF", color: "#0B1D37", fontSize: "0.9rem" }}
                      value={newsletterEmail}
                      onChange={(e) => setNewsletterEmail(e.target.value)}
                    />
                    <button
                      type="submit"
                      disabled={isSubmittingNews}
                      className="btn rounded-pill px-4 text-nowrap fw-bold shadow-sm"
                      style={{
                        background: "#FEA116",
                        color: "#0B1D37",
                        border: "2px solid #FEA116",
                        fontWeight: "800",
                        fontSize: "0.88rem",
                        letterSpacing: "0.04em",
                        boxShadow: "0 4px 14px rgba(254, 161, 22, 0.45)"
                      }}
                    >
                      {isSubmittingNews ? "JOINING..." : "JOIN VIP"}
                    </button>
                  </div>
                  {newsletterMsg && (
                    <span className="small text-warning fw-bold mt-1 d-block text-center">{newsletterMsg}</span>
                  )}
                </form>
              </div>
            </div>
          </div>
        )}

        <div className="row g-4 g-lg-5">
          {/* Brand / Story */}
          <div className="col-md-6 col-lg-4">
            <div className="hk-footer-brand hk-card hk-card--dark h-100">
              <Link to="/" className="hk-footer-logo-link">
                <div className="hk-footer-logo-text">
                  <span className="hk-footer-logo-main">HariKunj</span>
                  <span className="hk-footer-logo-sub">Resort &amp; Hotel, Jodhpur</span>
                </div>
              </Link>
              <p className="hk-footer-copy mt-3">
                A premier boutique Rajasthani sanctuary where{" "}
                <span>courtyard evenings</span>,{" "}
                <span>heritage architecture</span>, and{" "}
                <span>slow luxury</span> come together. From sunrise chai to
                starlit lawn celebrations, every stay is designed as a story you&apos;ll
                want to cherish.
              </p>

              {activeSocials.length > 0 && (
                <div className="hk-footer-social mt-3">
                  {activeSocials.map((item, index) => (
                    <a
                      key={index}
                      href={item.link}
                      target="_blank"
                      rel="noreferrer"
                      className="hk-footer-social-link"
                      aria-label={item.name}
                    >
                      {item.icon}
                    </a>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* Contact */}
          <div className="col-12 col-md-6 col-lg-3">
            <h6 className="hk-footer-heading">Contact &amp; Location</h6>
            <div className="hk-footer-contact">
              <p className="hk-footer-line">
                <span className="hk-footer-line-icon"><i className="fas fa-map-marker-alt" /></span>
                <span>{address}</span>
              </p>
              <p className="hk-footer-line">
                <span className="hk-footer-line-icon"><i className="fas fa-phone-alt" /></span>
                <span>{renderMultiFooterLinks(phone, "phone")}</span>
              </p>
              <p className="hk-footer-line">
                <span className="hk-footer-line-icon"><i className="fas fa-envelope" /></span>
                <span>{renderMultiFooterLinks(email, "email")}</span>
              </p>
            </div>
          </div>

          {/* Explore */}
          <div className="col-6 col-md-6 col-lg-2">
            <h6 className="hk-footer-heading">Explore</h6>
            <div className="hk-footer-links">
              <Link className="hk-footer-link" to="/gallery">
                Photo Gallery
              </Link>
              <Link className="hk-footer-link" to="/rooms">
                Rooms &amp; Suites
              </Link>
              <Link className="hk-footer-link" to="/services">
                Experiences
              </Link>
              <Link className="hk-footer-link" to="/attractions">
                Nearby Attractions
              </Link>
              <Link className="hk-footer-link" to="/testimonials">
                Guest Stories
              </Link>
              <Link className="hk-footer-link" to="/terms-and-conditions">
                Terms &amp; Conditions
              </Link>
              <Link className="hk-footer-link" to="/privacy-policy">
                Privacy Policy
              </Link>
            </div>
          </div>

          {/* Plan Your Stay */}
          <div className="col-6 col-md-6 col-lg-3">
            <h6 className="hk-footer-heading">Plan Your Stay</h6>
            <div className="hk-footer-links">
              <Link className="hk-footer-link" to="/booking">
                Book Room &amp; Lawn
              </Link>
              <Link className="hk-footer-link" to="/rooms">
                Royal Tariffs &amp; Suites
              </Link>
              <Link className="hk-footer-link" to="/about">
                About HariKunj
              </Link>
              <Link className="hk-footer-link" to="/contact">
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="hk-footer-bottom">
        <div className="container d-flex flex-column flex-md-row align-items-center justify-content-between gap-2">
          <p className="mb-0 hk-footer-bottom-text">
            © {new Date().getFullYear()} HariKunj Resort &amp; Hotel. All rights reserved.
          </p>
          <div className="mb-0 hk-footer-bottom-text hk-footer-bottom-links d-flex align-items-center gap-3">
            <Link to="/terms-and-conditions" className="text-light-50 text-decoration-none" style={{ color: "rgba(249, 239, 225, 0.8)", fontSize: "0.78rem" }}>Terms &amp; Conditions</Link>
            <span style={{ opacity: 0.4 }}>|</span>
            <Link to="/privacy-policy" className="text-light-50 text-decoration-none" style={{ color: "rgba(249, 239, 225, 0.8)", fontSize: "0.78rem" }}>Privacy Policy</Link>
            <span style={{ opacity: 0.4 }}>|</span>
            <span>Heritage-crafted in Rajasthan</span>
          </div>
        </div>
      </div>

      <style>{`
        .hk-footer-wrapper {
          position: relative;
          margin-top: 0px;
          background:
            radial-gradient(circle at top, rgba(212, 175, 55, 0.18), transparent 60%),
            linear-gradient(180deg, #0B1D37 0%, #050E1A 50%, #02070F 100%);
          padding-top: 40px;
          color: var(--hk-text-on-dark);
          border-top: 2px solid rgba(212, 175, 55, 0.5);
        }

        .hk-footer-overlay {
          position: absolute;
          inset: 0;
          background-image:
            radial-gradient(circle at 10% 0%, rgba(212, 175, 55, 0.12), transparent 55%),
            radial-gradient(circle at 90% 10%, rgba(30, 62, 114, 0.35), transparent 55%),
            url("/assets/img/pattern-jaali.png");
          background-size: auto, auto, 280px;
          background-repeat: no-repeat, no-repeat, repeat;
          opacity: 0.38;
          mix-blend-mode: soft-light;
          pointer-events: none;
        }

        .hk-footer-inner {
          position: relative;
          z-index: 1;
          padding-bottom: 40px;
        }

        .hk-footer-brand {
          padding: 2.2rem 2rem;
        }

        .hk-footer-logo-link {
          text-decoration: none;
        }

        .hk-footer-logo-text {
          text-transform: uppercase;
          letter-spacing: 0.26em;
        }

        .hk-footer-logo-main {
          display: block;
          font-family: "Cinzel Decorative", serif;
          font-size: 1.6rem;
          font-weight: 800;
          color: #ffe8c2;
          text-shadow:
            0 0 6px rgba(0, 0, 0, 0.85),
            0 0 14px rgba(255, 191, 105, 0.85);
        }

        .hk-footer-logo-sub {
          display: block;
          font-family: "Cinzel", serif;
          font-size: 0.75rem;
          font-weight: 600;
          color: #ffd9a1;
          letter-spacing: 0.26em;
          margin-top: 0.35rem;
          text-shadow:
            0 0 4px rgba(0, 0, 0, 0.9),
            0 0 10px rgba(221, 150, 63, 0.75);
        }

        .hk-footer-copy {
          font-size: 0.95rem;
          line-height: 1.6;
          color: rgba(250, 242, 230, 0.86);
        }

        .hk-footer-copy span {
          color: #ffd79a;
          font-weight: 600;
        }

        .hk-footer-social {
          display: flex;
          flex-wrap: wrap;
          gap: 0.6rem;
        }

        .hk-footer-social-link {
          width: 38px;
          height: 38px;
          border-radius: 999px;
          border: 1px solid rgba(246, 215, 167, 0.7);
          display: inline-flex;
          align-items: center;
          justify-content: center;
          font-size: 1.05rem;
          color: #ffe6c0;
          transition:
            background 0.25s ease,
            color 0.25s ease,
            transform 0.25s ease,
            box-shadow 0.25s ease;
        }

        .hk-footer-social-link:hover {
          background: linear-gradient(135deg, #fea116, #e38a12);
          color: #1b0f0b;
          transform: translateY(-3px);
          box-shadow: 0 10px 22px rgba(0, 0, 0, 0.5);
        }

        .hk-footer-heading {
          font-family: "Playfair Display", serif;
          font-size: 1rem;
          letter-spacing: 0.16em;
          text-transform: uppercase;
          color: #ffd6a1;
          margin-bottom: 1rem;
          position: relative;
        }

        .hk-footer-heading::after {
          content: "";
          display: block;
          width: 42px;
          height: 2px;
          border-radius: 999px;
          margin-top: 0.35rem;
          background: linear-gradient(90deg, #fea116, #f6d7a7);
        }

        .hk-footer-contact {
          font-size: 0.92rem;
          color: rgba(249, 239, 225, 0.9);
        }

        .hk-footer-line {
          display: flex;
          align-items: flex-start;
          gap: 0.45rem;
          margin-bottom: 0.45rem;
        }

        .hk-footer-line-icon {
          flex-shrink: 0;
          margin-top: 0.1rem;
          color: #f6d7a7;
        }

        .hk-footer-links {
          display: flex;
          flex-direction: column;
          gap: 0.3rem;
          font-size: 0.92rem;
        }

        .hk-footer-link {
          color: rgba(249, 239, 225, 0.86);
          text-decoration: none;
          position: relative;
          padding-left: 0.6rem;
          transition: color 0.2s ease;
        }

        .hk-footer-link::before {
          content: "›";
          position: absolute;
          left: 0;
          top: 0;
          color: #f6d7a7;
          opacity: 0.7;
        }

        .hk-footer-link:hover {
          color: #ffdba7;
        }

        .hk-footer-bottom {
          position: relative;
          z-index: 1;
          border-top: 1px solid rgba(246, 215, 167, 0.35);
          padding-block: 14px;
          background: radial-gradient(circle at top, rgba(0, 0, 0, 0.7), transparent 60%);
        }

        .hk-footer-bottom-text {
          font-size: 0.8rem;
          color: rgba(249, 239, 225, 0.8);
          letter-spacing: 0.12em;
          text-transform: uppercase;
        }

        .hk-footer-bottom-links {
          display: flex;
          flex-wrap: wrap;
          gap: 0.6rem;
        }

        @media (max-width: 767.98px) {
          .hk-footer-wrapper {
            margin-top: 48px;
            padding-top: 56px;
          }

          .hk-footer-brand {
            padding: 1.6rem 1.4rem;
          }

          .hk-footer-bottom-text {
            text-align: center;
          }
        }
      `}</style>
    </footer>
  );
}
